export const formatLatePay = (latePayNbr, preText, postText) => {
    let latePayText = "";
    if (latePayNbr > 12){
        const latePayYears = (latePayNbr / 12).toFixed(0);
        const latePayMonths = latePayNbr % 12;
        latePayText = preText + latePayYears + " years ";
        if (latePayMonths > 0){
            latePayText += latePayMonths + " months";
        }
    }else{
        const latePayMonths = latePayNbr;
        latePayText = preText + latePayMonths + " month(s)";
    }

    if (postText && postText !== ""){
        latePayText += postText;
    }
    return latePayText;
}
export default formatLatePay;